<div class="progress {{ displayLabel ? 'progress-with-label' : '' }}">
  <div class="progress-bar" [style.width.%]="value - weeksProgress"></div>
  <div class="weekly-progress-bar" [style.width.%]="weeksProgress"></div>
  @if (displayLabel) {
    <div class="label" [style.margin-left.px]="calculateMarginForLabel()">{{ value }}%</div>
  }
</div>
